import { Controller } from "@hotwired/stimulus"
import { Modal } from 'bootstrap'

export default class extends Controller {
  static targets = ['input', 'label']
  static values = {
    count: Number,
    maxFiles: Number,
    originalLabel: String
  }

  handleChange() {
    const max = this.maxFilesValue || 3;
    const files =  this.inputTarget.files;
    this.countValue = files.length;

    if (this.countValue > max) {      
      document.querySelector('#fileErrorCount').textContent = max;
      
      const modalElement = document.querySelector('#tooManyFilesError')
      const modalInstance = Modal.getOrCreateInstance(modalElement) // eslint-disable-line
      modalInstance.show()
      this.inputTarget.value = ""
      this.labelTarget.innerHTML = this.originalLabelValue
      return
    }

    if (this.countValue > 0) {
      this.countValues = this.inputTarget.files.length;
      this.labelTarget.textContent = `${this.countValue} ${this.countValue > 1 ? 'fichiers ajoutés' : 'fichier ajouté'}`
    } else {
      this.labelTarget.textContent = this.originalLabelValue
    }
  }
}
